const loadBookItV2 = (id, node, nodeName) => {
  /* eslint-disable */
  const orgId = "00D60000000Jrn8EAC"; // Replace with your SFDC id
  // const nodeName = "New Prospect"; // Replace with your BookIt node name
  const hiddenFieldName = "ld_bookit_log_id"; // Replace with your hidden field name

  function trySettingFormTarget(form) {
    if (window['LDBookItV2'] && window['LDBookItV2'].setFormTarget) {
      LDBookItV2.setFormTarget(form.id ? form : form[0]);
    }
    else {
      window.setTimeout(() => trySettingFormTarget(form), 2000);
    }
  }

  let _ld_scriptEl = document.createElement('script');
  _ld_scriptEl.src = 'https://cdn.leandata.com/js-snippet/ld-book-v2.js';
  _ld_scriptEl.addEventListener('load', function () {
    LDBookItV2.initialize(orgId, nodeName, hiddenFieldName, { autoSubmit: true });
    LDBookItV2.setFormProvider('hubspot_embed');

    const forms = document.querySelectorAll(`form.hs-form-${id}`);
    forms.forEach(form => trySettingFormTarget(form));
  });
  document.body.appendChild(_ld_scriptEl);

  window.addEventListener("message", function (e) {
    // Once someone submits the calendar, it will route to the thank you page
    if (e.data.message === "LD_POST_BOOKING") {
      window.location = "/thank-you/schedule-a-demo";
    }
    // Once someone exits out of the modal prematurely, it will reload the page
    if (e.data.message === "LD_POPUP_CLOSED") {
      window.location.reload();
    }
  });
  trySettingFormTarget(node);
  /* eslint-enable */
};

export default loadBookItV2;
